import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { PHONE_ERROR_AT_LEAST_ONE_NUMBER_REQUIRED, PHONE_ERROR_INVALID_NUMBER } from 'src/common/validation/errors';
import * as Yup from 'yup';

export function getSinglePhoneValidator() {
  return Yup.string()
    .nullable()
    .default(null)
    .test({
      message: PHONE_ERROR_INVALID_NUMBER,
      test: (phone: string | null) => {
        // If phone number is empty then no error
        return !phone || isPossiblePhoneNumber(phone);
      },
    });
}

export function getPhoneValidator(mainPhoneName: string, additionalPhoneName: string) {
  return getSinglePhoneValidator().test(
    mainPhoneName,
    PHONE_ERROR_AT_LEAST_ONE_NUMBER_REQUIRED,
    (mainPhone: string | null, context) => {
      // If both phone numbers is empty then show `at least one required` error for both
      return !!mainPhone || !!context.parent[additionalPhoneName];
    }
  );
}
